import React, { useState } from 'react';
import { DateTime, Interval } from "luxon";
import styled from 'styled-components';
import { Limits } from './Limits';
import { LastSample } from './LastSample';
import { colour_lookup } from '../../common/Colours';

const Table = styled.table`
  width: 90%;
  margin: 0 auto 20px auto;
`;

const Row = styled.tr`
  colour: #292D34;
  font-size: 18px;
  padding 20px 0;
  border: 1px solid #dddddd;
`;

const ExpandedRow = styled.tr`
  colour: #292D34;
  font-size: 18px;
`;

const HeadingCell = styled.th`
  vertical-align: middle;
  height: 40px;
  font-size: 16px;
  text-align: left;
  padding: 8px 10px;
`;

const Cell = styled.td`
  vertical-align: middle;
  padding: 8px 10px;
  font-size: 14px;
  text-align: left;
`;

const ExpandCell = styled.td<{ expanded: boolean; }>`
  vertical-align: middle;
  padding: ${props => props.expanded? '0px 0px' : '8px 0px'};
  cursor: pointer;
`;

const ExpandedCell = styled.td.attrs(props => ({
  colSpan: props.colSpan
}))<{ colSpan: any; expanded: boolean; }>`
  vertical-align: middle;
  padding: ${props => props.expanded? '0px 0px 8px 0px' : '8px 0px'};
`;

const CellContent = styled.div<{ textAlign?: string; }>`
  padding: 10px 10px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  text-align: ${props => props.textAlign || 'left'};
`;

const StartCellContent = styled.div<{ colour: string; textAlign?: string; }>`
  padding: 10px 5px;
  border-top: 1px solid ${props => props.colour || '#DDD'};
  border-bottom: 1px solid ${props => props.colour || '#DDD'};
  border-left: 1px solid ${props => props.colour || '#DDD'};
  border-radius: 5px 0 0 5px;
  background: ${props => props.colour || '#DDD'};
  text-align: ${props => props.textAlign || 'left'};
`;

const EndCellContent = styled.div<{ expanded: boolean; }>`
  padding: 10px 10px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  border-radius: ${props => props.expanded? '0 5px 0 0' : '0 5px 5px 0'};
`;

const BlankCellContent = styled.div`
  padding: 10px 10px;
`;

const StyledTimeperiodSelector = styled.div`
`;


const HourText = styled.text`
  text-anchor: middle;
  font-size: 15px;
`;

const PeriodRect = styled.rect<{ colour: string }>`
  fill: ${props => props.colour};
  cursor: pointer;
`;

const getExceededColour = (last_sample, period) => {
  const in_future = period.start > DateTime.local() || period.start > DateTime.fromISO(last_sample);
  if (in_future) return colour_lookup('grey');

  let exceeded = false;
  period.limits.forEach(limit => {
    if (limit.total_exceedances > 0) {
      exceeded = true;
    }
  });
  if (exceeded) return colour_lookup('red');
  return colour_lookup('green');
}

const periodInFocus = (period) => {
  if (period.is_selected) {
    return true;
  } else {
    return false;
  }
}

export const TimeperiodSelector = ({ lastSample, timeperiods, setFocusedTimeperiod }: { lastSample: any; timeperiods: any; setFocusedTimeperiod: any; }) => {
  
  return (
    <StyledTimeperiodSelector>
      <svg width='100%' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 100'>
        <g transform={`translate(${(1000/26)},0)`}>
          {Array(25).fill(1).map((value, index) => (
            <HourText x={(index) * (1000/26)} y="35">{index.toString().padStart(2, '0')}</HourText>
          ))}
          {timeperiods.map((period, index) => (
            <PeriodRect onClick={() => { setFocusedTimeperiod(period.start.toISO(), period.end.toISO()) }} colour={getExceededColour(lastSample, period)} x={(period.start_hour) * (1000/26)} y={periodInFocus(period)? '45' : '50'} width={(period.end_hour - period.start_hour) * (1000/26)} height={periodInFocus(period)? '40' : '30'}/>
          ))}
          {timeperiods.map((period, index) => (
            <React.Fragment>
              <line x1={(period.start_hour) * (1000/26)} y1={period.start_hour? '45' : '50'} x2={(period.start_hour) * (1000/26)} y2={period.start_hour? '90' : '80'} stroke='#FFFFFF' strokeWidth='2' strokeDasharray='2'/>
              <line x1={(period.end_hour) * (1000/26)} y1={period.selected? '45' : '50'} x2={(period.end_hour) * (1000/26)} y2={period.selected? '90' : '80'} stroke='#FFFFFF' strokeWidth='2' strokeDasharray='2'/>
            </React.Fragment>
          ))}
        </g>
        {false && <rect width="300" height="20" />}
      </svg>
    </StyledTimeperiodSelector>
  )
}